var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_603_4737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2001 5.76001V26.24H23.8001V10.6599L18.8237 5.76001H8.2001ZM6.9001 3.20001H19.9001L26.0192 9.22497C26.263 9.46496 26.4 9.79048 26.4001 10.1299V27.52C26.4001 27.8595 26.2631 28.1851 26.0193 28.4251C25.7755 28.6652 25.4449 28.8 25.1001 28.8H6.9001C6.55532 28.8 6.22466 28.6652 5.98086 28.4251C5.73706 28.1851 5.6001 27.8595 5.6001 27.52V4.48001C5.6001 4.14054 5.73706 3.81496 5.98086 3.57492C6.22466 3.33487 6.55532 3.20001 6.9001 3.20001ZM17.3001 13.44V23.68H14.7001V16H10.8001V13.44H17.3001ZM10.8001 17.28H13.4001V19.84H10.8001V17.28ZM18.6001 17.28H21.2001V19.84H18.6001V17.28ZM18.6001 13.44H21.2001V16H18.6001V13.44ZM10.8001 21.12H13.4001V23.68H10.8001V21.12ZM18.6001 21.12H21.2001V23.68H18.6001V21.12Z",
    fill: "#282828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_603_4737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimIcon);
export default __webpack_public_path__ + "static/media/sim-icon.9a7f5624e3dae21c4fcc4c03d5b4d387.svg";
export { ForwardRef as ReactComponent };